/* eslint-disable no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isInitialized: "connecting",
    socketData: null,
};

export const slice = createSlice({
    name: "socketSlice",
    initialState,
    reducers: {
        setSocketState: (_state, _action) => {
            const { user, isInitialized } = _action.payload;
            return {
                ..._state,
                isInitialized: isInitialized,
                socketData: user,
            };
        },
    },
});
export const {
    setSocketState,
} = slice.actions;

export default slice.reducer;
